import React from "react";
import { StyleSheet } from "react-native";
import { View } from "@components/atoms/Themed";
import NavigationBar from "@components/molecules/NavigationBar";
import { goBack } from "@navigation/navigate";
import AuthLogin from "@components/templates/AuthLogin";

export default function AuthLoginScreen(): JSX.Element {
  return (
    <View style={styles.content}>
      <NavigationBar onBack={goBack} title="ログイン" />
      <AuthLogin />
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    flex: 1,
  },
});
